// import waterfall from 'async/waterfall';
import { setOrders } from './orders';
import { toggleLoadingOverlay } from '../../redux/actions/display';

export const loginApp = (email, password) => {
  const requestCRM = fetch('/api/login',
    {
      method: 'POST',
      body: JSON.stringify({
        email,
        password,
      }),
      headers: {"Content-Type": "application/json"}
    }
  );

  return (dispatch) => {
    dispatch(toggleLoadingOverlay('ordersLayout.loading'));
    requestCRM.then(response => {
      dispatch({ type: 'TOGGLE_LOADING_OVERLAY' });
      if (response.status === 200) {
        dispatch({ type: 'LOGIN_APP', email: email });

        // Gary: Get Order from CRM here (in-progress)
        // dispatch(setOrders({ email: email }));
      } else if ([400, 401].indexOf(response.status) !== -1) {
        response.json().then(data => {
          if (data.errorCode === 'ERR001') alert('Your e-mail record does not exist in our system.');
          if (data.errorCode === 'ERR002') alert('E-mail or password is incorrect');
        })
        // debugger
      } else if (response.status === 500) {
        alert('server error, try again later');
      } else {
        alert('server error, try again later');
      }
    })
    .catch(error => {
      dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
      alert('OOPS! Something went wrong');
    })
  }
};

export const loginAppDirectly = (email) => {
  const requestCRM = fetch('/api/login/directly',
    {
      method: 'POST',
      body: JSON.stringify({
        email,
      }),
      headers: {"Content-Type": "application/json"}
    }
  );

  return (dispatch) => {
    dispatch(toggleLoadingOverlay('ordersLayout.loading'));
    requestCRM.then(response => {
      if (response.status === 200) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });

        // Gary: Get Order from CRM here (in-progress)
        response.json().then(data => {
          if (data.id !== undefined) {
            // dispatch(setOrders({ crm_id: data.id }));
            dispatch({ type: 'SET_USERNAME', userName: data.userName });
            dispatch({ type: 'SET_CRMID', CrmId: data.id });
            dispatch({ type: 'LOGIN_APP_DITECTLY', email: email });
          }
        })
      }
      else if ([400, 401].indexOf(response.status) !== -1) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
        response.json().then(data => {
          if (data.errorCode === 'ERR001') alert('Your e-mail record does not exist in our system.');
          // if (data.errorCode === 'ERR002') alert('E-mail or password is incorrect');
          if (data.errorCode === 'ERR002') alert('Unauthorized');
        })
        // debugger
      }
      else if (response.status === 500) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
        alert('server error, try again later');
      }
    })
    .catch(error => {
      dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
      alert('OOPS! Something went wrong');
    })
  }
};

export const loginApp2FA = (code2fa, email) =>{
  const requestCRM = fetch('/api/login/verify',
    {
      method: 'POST',
      body: JSON.stringify({
        code2fa,
        email
      }),
      headers: {'Content-Type': 'application/json'}
    }
  );

  return (dispatch) => {
    dispatch(toggleLoadingOverlay('ordersLayout.loading'));
    requestCRM.then(response => {
      if (response.status === 200) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
        dispatch({ type: 'LOGIN_APP_2FA', code2fa: code2fa });
        response.json().then(data => {
          if (data.id !== undefined) {
            dispatch(setOrders({ crm_id: data.id }));
            dispatch(setCredits(data.id));
          }
        })
      }
      else if ([400, 401].indexOf(response.status) !== -1) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
        response.json().then(data => {
          if (data.errorCode === 'ERR003') alert('Your 2FA code is incorrect, or session expired.\nPlease refresh and try again.');
        })
        // debugger
      }
      else if (response.status === 500) {
        dispatch({ type: 'TOGGLE_LOADING_OVERLAY'  });
        alert('server error, try again later');
      }
    })
    .catch(error => {
      dispatch({ type: 'TOGGLE_LOADING_OVERLAY',  });
      alert('OOPS! Something went wrong');
    })
  }
};

export const logoutApp = () =>({
  type: 'LOGOUT_APP'
});

// export const signUpApp = (username, email, password) =>{
export const signUpApp = (username, email) =>{
  const request = fetch('/api/signup',
    {
      method: 'POST',
      body: JSON.stringify({
        username,
        email,
        password: '',
      }),
      headers: {"Content-Type": "application/json"}
    }
  );

  return (dispatch) => {
    request.then(response => {
      if(response.status === 401){
        alert('username already exists');
      }
      else if(response.status === 500){
        alert('server error, try again later');
      }
    })
    .catch(error => {
      alert('OOPS! Something went wrong');
    })
  }
};

export const setCredits = (crm_id) =>{
  const requestCREDITS = fetch('/api/credits',
    {
      method: 'POST',
      body: JSON.stringify({
        crm_id
      }),
      headers: {'Content-Type': 'application/json'}
    }
  );

  return (dispatch) => {
    requestCREDITS.then(response => {
      if (response.status === 200) {
        response.json().then(data => {
          if (data.success) {
            dispatch({
              type: 'SET_CREDITS',
              credits: data.items
            });
            dispatch({ type: 'SET_INIT_CREDITS' });
          } else {
            alert(data.message);
          }
        })
      }
      else if ([400, 401].indexOf(response.status) !== -1) {
        response.json().then(data => {
          alert(data.message);
        })
      }
      else if (response.status === 500) {
        alert('server error, try again later');
      }
    })
    .catch(error => {
      alert('OOPS! Something went wrong');
    })
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/app.js